import { CartItemSet } from '../CartItemSet'
import { CartItemSlot } from '../CartItemSlot'
import { CartItem } from '../CartItem'
import { cartItemsBle } from './cartItemsBle'
import { cartItemsNfc } from './cartItemsNfc'
import { cartItemsPlus } from './cartItemsPlus'
import { cartItemsPro } from './cartItemsPro'
import { cartItemsNft } from './cartItemsNft'

export const CartItems = new Map<CartItemSet, Map<CartItemSlot, CartItem>>([
  [CartItemSet.Ble, cartItemsBle],
  [CartItemSet.Nfc, cartItemsNfc],
  [CartItemSet.Nft, cartItemsNft],
  [CartItemSet.Plus, cartItemsPlus],
  [CartItemSet.Pro, cartItemsPro],
])
